export const AlertEnum = {
    TITLE: {
        WARNING: "Warning"
    },
    MESSAGE: {
        BUSY: "Sorry, we're very busy, please select another time slot"
    }
}